import { useRef } from "react";

export default function Select ({children, className, name, id, onChange, value, style, disabled, title, required, defaultValue}) {
    let reference = useRef();
    function closeDropdown() {
        reference.current.blur();
        if (reference?.current.browser?.webkit) {
            reference.current.hide();
            setTimeout(() => {
                reference?.current.show()
            }, 5);
            }
    }
   return ( 
        <select 
            className={className}
            name={name}
            id={id}
            onChange={onChange}
            value={value}
            onMouseLeave={closeDropdown}
            ref={reference}
            style={style}
            disabled={disabled}
            title={title}
            required={required}
            defaultValue={defaultValue}
        >
            {children}
        </select>
   )
}